<template>
  <div class="_80_w d-flex align-center flex-column px-3 py-5">
    <v-tabs v-model="category" color="#006341" centered>
      <v-tab>Personal Info</v-tab>
      <v-tab>Education</v-tab>
      <v-tab>Activity</v-tab>
      <v-tab>Family</v-tab>
      <v-tab>Finance</v-tab>
      <v-tab>Others</v-tab>
      <v-tabs-items v-model="category">
        <div class="d-flex align-center flex-column">
          <v-row no-gutters class="full_w" v-if="!loading">
            <v-col
              v-for="(item, index) in dataBody"
              :key="index"
              cols="12"
              md="12"
            >
              <div class="full_w" v-if="item.category == category">
                <div class="pa-2" v-if="item.type == 'string'">
                  <h4 class="text-capitalize">{{ item.label }}</h4>
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'VENDOR' ||
                      role == 'SUPERADMIN'
                        ? false
                        : true
                    "
                    dense
                    v-if="!item.risk"
                    v-model="item.value"
                    placeholder="Type Here"
                    hide-details
                    color="green"
                    :rules="item.rules"
                    outlined
                    class="rounded-lg"
                  ></v-text-field>
                  <v-card
                    outlined
                    class="d-flex align-center justify-space-between rounded-lg"
                    v-if="item.risk"
                  >
                    <p class="mb-0 pa-2">
                      {{ item.value ? `${item.value.slice(0, -3)}***` : "-" }}
                    </p>
                    <v-btn icon class="ml-2" @click="editRisk(item)">
                      <v-icon
                        small
                        v-if="
                          permissions.includes('UPCM') ||
                          role == 'VENDOR' ||
                          role == 'SUPERADMIN'
                        "
                        >mdi-pencil</v-icon
                      >
                      <v-icon small v-else>mdi-eye</v-icon>
                    </v-btn>
                  </v-card>
                </div>
                <div class="pa-2" v-if="item.type == 'integer'">
                  <h4 class="text-capitalize">{{ item.label }}</h4>
                  <v-select
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'VENDOR' ||
                      role == 'SUPERADMIN'
                        ? false
                        : true
                    "
                    v-if="item.name == 'university_id'"
                    dense
                    :items="optUniv"
                    item-text="name"
                    item-value="id"
                    v-model="item.value"
                    placeholder="Choose University"
                    hide-details
                    outlined
                    class="rounded-lg"
                  ></v-select>
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'VENDOR' ||
                      role == 'SUPERADMIN'
                        ? false
                        : true
                    "
                    v-else
                    dense
                    v-model="item.value"
                    placeholder="Type Here"
                    hide-details
                    color="green"
                    type="number"
                    outlined
                    class="rounded-lg"
                  ></v-text-field>
                </div>
                <div class="pa-2" v-if="item.type == 'select'">
                  <div v-if="opt[item.name]">
                    <h4 class="text-capitalize">{{ item.label }}</h4>
                    <v-select
                      :disabled="
                        permissions.includes('UPCM') ||
                        role == 'VENDOR' ||
                        role == 'SUPERADMIN'
                          ? false
                          : true
                      "
                      @change="changeHandler(item.value, item.name)"
                      dense
                      :items="opt[item.name]"
                      item-text="txt"
                      item-value="val"
                      v-model="item.value"
                      :placeholder="`Choose ${item.label}`"
                      hide-details
                      outlined
                      class="rounded-lg"
                      color="green"
                    ></v-select>
                  </div>
                  <div
                    v-if="
                      item.need_country && country !== '' && country !== 'ID'
                    "
                  >
                    <h4 class="text-capitalize">{{ item.label }}</h4>
                    <v-text-field
                      :disabled="
                        permissions.includes('UPCM') ||
                        role == 'VENDOR' ||
                        role == 'SUPERADMIN'
                          ? false
                          : true
                      "
                      dense
                      v-model="item.value"
                      placeholder="Type Here"
                      hide-details
                      color="green"
                      outlined
                      class="rounded-lg"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pa-2" v-if="item.type == 'date'">
                  <h4 class="text-capitalize">{{ item.label }}</h4>
                  <v-menu
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'VENDOR' ||
                      role == 'SUPERADMIN'
                        ? false
                        : true
                    "
                    v-model="showPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="
                          permissions.includes('UPCM') ||
                          role == 'VENDOR' ||
                          role == 'SUPERADMIN'
                            ? false
                            : true
                        "
                        v-model="item.value"
                        prepend-inner-icon="mdi-calendar-range"
                        readonly
                        hide-details
                        dense
                        v-on="on"
                        outlined
                        class="rounded-lg"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="item.value"
                      @input="closeDateMenu(item, index)"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="pa-2" v-if="item.type == 'enum'">
                  <h4 class="text-capitalize">{{ item.label }}</h4>
                  <v-radio-group
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'VENDOR' ||
                      role == 'SUPERADMIN'
                        ? false
                        : true
                    "
                    v-model="item.value"
                    v-if="item.name != 'type'"
                    hide-details
                    class="ma-0"
                    dense
                    row
                  >
                    <v-radio
                      label="Male"
                      color="#006341"
                      value="Male"
                    ></v-radio>
                    <v-radio
                      label="Female"
                      color="#006341"
                      value="Female"
                    ></v-radio>
                  </v-radio-group>
                  <v-radio-group
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'VENDOR' ||
                      role == 'SUPERADMIN'
                        ? false
                        : true
                    "
                    v-model="item.value"
                    v-if="item.name == 'type'"
                    class="mt-1 mb-2"
                    hide-details
                    dense
                    row
                  >
                    <v-radio
                      label="Regular"
                      color="#006341"
                      value="regular"
                    ></v-radio>
                    <v-radio
                      label="Non Regular"
                      color="#006341"
                      value="non-regular"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div class="pa-2" v-if="item.type == 'text' && ((category == 5 && item.name == 'documents') || category != 5)">
                    <h4 class="text-capitalize">{{ item.label }}</h4>
                    <div
                      v-if="
                        item.name == 'historical_edu' ||
                        item.name == 'achievement' ||
                        item.name == 'orgs_activity' ||
                        item.name == 'language_ability' ||
                        item.name == 'father_latest_edu' ||
                        item.name == 'mother_latest_edu' ||
                        item.name == 'acc_socmed' ||
                        item.name == 'address'
                      "
                    >
                      <div v-if="item.name == 'address'">
                        <v-textarea
                          :disabled="
                            permissions.includes('UPCM') ||
                            role == 'VENDOR' ||
                            role == 'SUPERADMIN'
                              ? false
                              : true
                          "
                          class="my-1 rounded-lg"
                          auto-grow
                          rows="4"
                          placeholder="Type Here"
                          hide-details
                          v-model="item.value"
                          dense
                          outlined
                        ></v-textarea>
                      </div>
                      <div class="pl-3" v-if="item.name == 'acc_socmed'">
                        <div
                          v-for="(sosmed, idx) in acc_socmed"
                          :key="`sosmed-${idx}`"
                        >
                          <h6 style="font-weight: normal" class="text-capitalize">
                            {{ sosmed.name }}
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            :placeholder="sosmed.name"
                            v-model="sosmed.value"
                            hide-details
                            dense
                            outlined
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="pl-3" v-if="item.name == 'achievement'">
                        <div
                          v-for="(achievementItem, idx) in achievement"
                          :key="`achievementItem-${idx}`"
                        >
                          <h6 style="font-weight: normal" class="text-capitalize">
                            {{ `Achievement ${idx + 1}` }}
                          </h6>
                          <div class="d-flex align-center">
                            <v-text-field
                              :disabled="
                                permissions.includes('UPCM') ||
                                role == 'VENDOR' ||
                                role == 'SUPERADMIN'
                                  ? false
                                  : true
                              "
                              class="my-1 rounded-lg"
                              :placeholder="`Achievement ${idx + 1}`"
                              hide-details
                              dense
                              outlined
                              v-model="achievementItem.val"
                            ></v-text-field>
                            <v-icon
                              :disabled="
                                permissions.includes('UPCM') ||
                                role == 'VENDOR' ||
                                role == 'SUPERADMIN'
                                  ? false
                                  : true
                              "
                              class="ml-2"
                              @click="
                                removeField(achievementItem.id, achievement)
                              "
                              >mdi-trash-can-outline</v-icon
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-end">
                          <v-btn
                            v-if="permissions.includes('UPCM')"
                            depressed
                            class="mt-2 rounded-lg"
                            @click="addField(achievement)"
                            dark
                            color="var(--g)"
                            >Add field</v-btn
                          >
                        </div>
                      </div>
                      <div class="pl-3" v-if="item.name == 'historical_edu'">
                        <div
                          v-for="(historical_eduItem, idx) in historical_edu"
                          :key="`historical_eduItem-${idx}`"
                        >
                          <h6 style="font-weight: normal" class="text-capitalize">
                            {{ `Education ${idx + 1}` }}
                          </h6>
                          <div class="d-flex align-center">
                            <v-text-field
                              :disabled="
                                permissions.includes('UPCM') ||
                                role == 'VENDOR' ||
                                role == 'SUPERADMIN'
                                  ? false
                                  : true
                              "
                              class="my-1 rounded-lg"
                              :placeholder="`Education ${idx + 1}`"
                              hide-details
                              dense
                              outlined
                              v-model="historical_eduItem.val"
                            ></v-text-field>
                            <v-icon
                              :disabled="
                                permissions.includes('UPCM') ||
                                role == 'VENDOR' ||
                                role == 'SUPERADMIN'
                                  ? false
                                  : true
                              "
                              class="ml-2"
                              @click="
                                removeField(historical_eduItem.id, historical_edu)
                              "
                              >mdi-trash-can-outline</v-icon
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-end">
                          <v-btn
                            v-if="permissions.includes('UPCM')"
                            depressed
                            class="mt-2 rounded-lg"
                            @click="addField(historical_edu)"
                            dark
                            color="var(--g)"
                            >Add field</v-btn
                          >
                        </div>
                      </div>
                      <div class="pl-3" v-if="item.name == 'orgs_activity'">
                        <div
                          v-for="(orgs_activityItem, idx) in orgs_activity"
                          :key="`orgs_activityItem-${idx}`"
                        >
                          <h6 style="font-weight: normal" class="text-capitalize">
                            {{ `Organization activity ${idx + 1}` }}
                          </h6>
                          <div class="d-flex align-center">
                            <v-text-field
                              :disabled="
                                permissions.includes('UPCM') ||
                                role == 'VENDOR' ||
                                role == 'SUPERADMIN'
                                  ? false
                                  : true
                              "
                              class="my-1 rounded-lg"
                              :placeholder="`Organization activity ${idx + 1}`"
                              hide-details
                              dense
                              outlined
                              v-model="orgs_activityItem.val"
                            ></v-text-field>
                            <v-icon 
                              :disabled="
                                permissions.includes('UPCM') ||
                                role == 'VENDOR' ||
                                role == 'SUPERADMIN'
                                  ? false
                                  : true
                              "
                              class="ml-2"
                              @click="
                                removeField(orgs_activityItem.id, orgs_activity)
                              "
                              >mdi-trash-can-outline</v-icon
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-end">
                          <v-btn
                            v-if="permissions.includes('UPCM')"
                            depressed
                            class="mt-2 rounded-lg"
                            @click="addField(orgs_activity)"
                            dark
                            color="var(--g)"
                            >Add field</v-btn
                          >
                        </div>
                      </div>
                      <div class="pl-3" v-if="item.name == 'father_latest_edu'">
                        <div
                          v-for="(
                            father_latest_eduItem, idx
                          ) in father_latest_edu"
                          :key="`father_latest_eduItem-${idx}`"
                        >
                          <h6 style="font-weight: normal" class="text-capitalize">
                            {{ `Father Education ${idx + 1}` }}
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            :placeholder="`Father Education ${idx + 1}`"
                            hide-details
                            dense
                            outlined
                            v-model="father_latest_eduItem.val"
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="pl-3" v-if="item.name == 'mother_latest_edu'">
                        <div
                          v-for="(
                            mother_latest_eduItem, idx
                          ) in mother_latest_edu"
                          :key="`mother_latest_eduItem-${idx}`"
                        >
                          <h6 style="font-weight: normal" class="text-capitalize">
                            {{ `Mother Education ${idx + 1}` }}
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            :placeholder="`Mother Education ${idx + 1}`"
                            hide-details
                            dense
                            outlined
                            v-model="mother_latest_eduItem.val"
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="pl-3" v-if="item.name == 'language_ability'">
                        <div
                          v-for="(language_abilityItem, idx) in language_ability"
                          :key="`language_abilityItem-${idx}`"
                        >
                          <h5 class="text-capitalize">
                            {{ `Language Ability ${idx + 1}` }}
                          </h5>
                          <h6 style="font-weight: normal" class="text-capitalize">
                            Language
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            placeholder="Language"
                            hide-details
                            dense
                            v-model="language_abilityItem.bahasa"
                            outlined
                          ></v-text-field>
                          <h6 style="font-weight: normal" class="text-capitalize">
                            Certification
                          </h6>
                          <v-radio-group
                            v-model="language_abilityItem['Memiliki Sertifikasi']"
                            hide-details
                            class="mt-0 mb-2"
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            row
                          >
                            <v-radio
                              color="var(--g)"
                              label="Yes"
                              value="Yes"
                            ></v-radio>
                            <v-radio
                              color="var(--g)"
                              label="No"
                              value="No"
                            ></v-radio>
                          </v-radio-group>
                          <!-- <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            placeholder="Memiliki Sertifikasi"
                            hide-details
                            dense
                            outlined
                            v-model="language_abilityItem['Memiliki Sertifikasi']"
                          ></v-text-field> -->
                          <h6 style="font-weight: normal" class="text-capitalize">
                            Test Type
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            hide-details
                            placeholder="Test Type"
                            dense
                            outlined
                            v-model="language_abilityItem['Jenis Tes']"
                          ></v-text-field>
                          <h6 style="font-weight: normal" class="text-capitalize">
                            Score
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            hide-details
                            placeholder="Score"
                            dense
                            outlined
                            v-model="language_abilityItem['Skor']"
                          ></v-text-field>
                          <h6 style="font-weight: normal" class="text-capitalize">
                            Certification Year
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            hide-details
                            placeholder="Certification Year"
                            dense
                            outlined
                            v-model="language_abilityItem['Tahun Sertifikat']"
                          ></v-text-field>
                          <h6 style="font-weight: normal" class="text-capitalize">
                            Institution Name
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            hide-details
                            placeholder="Institution Name"
                            dense
                            outlined
                            v-model="language_abilityItem['Nama Lembaga Bahasa']"
                          ></v-text-field>
                          <h6 style="font-weight: normal" class="text-capitalize">
                            Active Until
                          </h6>
                          <v-text-field
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            class="my-1 rounded-lg"
                            hide-details
                            placeholder="Active Until"
                            dense
                            outlined
                            v-model="language_abilityItem['Masa Berlaku']"
                          ></v-text-field>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <v-row
                        align="center"
                        justify="center"
                        v-if="item.value != null && item.change == false"
                        class="pa-2"
                      >
                        <v-col cols="1">
                          <v-icon> mdi-image </v-icon>
                        </v-col>
                        <v-col cols="9">
                          <a :href="item['value']" class="default_txt">
                            {{ item["value"] }}
                          </a>
                        </v-col>
                        <v-col cols="2">
                          <v-btn
                            :disabled="
                              permissions.includes('UPCM') ||
                              role == 'VENDOR' ||
                              role == 'SUPERADMIN'
                                ? false
                                : true
                            "
                            icon
                            @click="deleteImage(index)"
                          >
                            <v-icon color="red lighten-1"> mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <div v-else>
                        <v-text-field
                        :disabled="
                          permissions.includes('UPCM') ||
                          role == 'VENDOR' ||
                          role == 'SUPERADMIN'
                            ? false
                            : true
                        "
                        dense
                        v-if="item.name == 'documents'"
                        v-model="item.valueChange"
                        placeholder="Type Here"
                        hide-details
                        color="green"
                        :rules="item.rules"
                        outlined
                        class="rounded-lg"
                      ></v-text-field>
                      <v-file-input
                        :disabled="
                          permissions.includes('UPCM') ||
                          role == 'VENDOR' ||
                          role == 'SUPERADMIN'
                            ? false
                            : true
                        "
                        v-else
                        :rules="rules"
                        accept=".docx, .pdf, .jpg"
                        hide-details
                        dense
                        placeholder="Upload File"
                        prepend-inner-icon="mdi-image"
                        prepend-icon=""
                        :label="item.label"
                        outlined
                        class="rounded-lg"
                        v-model="item.valueChange"
                      ></v-file-input>
                      </div>
                    </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-tabs-items>
    </v-tabs>
    <div
      class="d-flex _80_w justify-end mt-2"
      v-if="
        permissions.includes('UPCM') || role == 'VENDOR' || role == 'SUPERADMIN'
      "
    >
      <v-btn
        class="bg_default text-capitalize rounded-lg"
        @click="updateData"
        depressed
        dark
        >Save</v-btn
      >
    </div>
    <v-overlay :absolute="true" color="white" opacity=".5" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
    <div class="pa-3">
      <UpdateRiskField
        :d_risk="d_risk"
        :inventory="inventory"
        @close="d_risk = false"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UpdateRiskField from "./updateRiskField.vue";
export default {
  name: "updateScholar",
  components: { UpdateRiskField },
  props: ["person"],
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: true,
      dataForm: null,
      d_risk: false,
      inventory: null,
      dataBody: [],
      showPicker: false,
      country: "",
      optRegencies: [],
      optDistrict: [],
      optVillage: [],
      optUniv: [],
      category: 0,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
      rules: [
        (value) =>
          !value ||
          value.size < 4000000 ||
          "File size should be less than 4 MB!",
      ],
      error: [],
      opt: {
        country: null,
        province: null,
        city: null,
        village: null,
        religion: null,
      },
      optReligion: [
        { txt: "Islam", val: "islam" },
        { txt: "Katolik", val: "katolik" },
        { txt: "Konghucu", val: "konghucu" },
        { txt: "Kristen", val: "kristen" },
        { txt: "Hindu", val: "hindu" },
        { txt: "Buddha", val: "buddha" },
      ],
      acc_socmed: [
        {
          name: "Instagram",
          value: "",
        },
        {
          name: "Linkedin",
          value: "",
        },
        {
          name: "Facebook",
          value: "",
        },
        {
          name: "Youtube",
          value: "",
        },
        {
          name: "Twitter",
          value: "",
        },
      ],
      historical_edu: [
        {
          id: 1,
          val: "",
        },
        {
          id: 2,
          val: "",
        },
        {
          id: 3,
          val: "",
        },
      ],
      achievement: [
        {
          id: 1,
          val: "",
        },
        {
          id: 2,
          val: "",
        },
        {
          id: 3,
          val: "",
        },
      ],
      orgs_activity: [
        {
          id: 1,
          val: "",
        },
        {
          id: 2,
          val: "",
        },
        {
          id: 3,
          val: "",
        },
      ],
      mother_latest_edu: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      father_latest_edu: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      language_ability: [
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
      ],
    };
  },
  async mounted() {
    this.dataUniv();
    // await this.checkDataAddress();
    await this.getForm();
  },
  methods: {
    editRisk(data) {
      this.inventory = data;
      this.d_risk = true;
    },
    changeHandler(val, key) {
      let idxProv = this.dataBody.findIndex((el) => {
        return el.name == "province";
      });
      let idxCity = this.dataBody.findIndex((el) => {
        return el.name == "city";
      });
      let idxVillage = this.dataBody.findIndex((el) => {
        return el.name == "village";
      });
      let allIdx = [idxProv, idxCity, idxVillage];

      if (key == "country") {
        this.country = val;
        if (val == "ID") {
          this.fetchDataProvince();
        } else {
          this.opt.province = null;
          this.opt.city = null;
          this.opt.village = null;
          allIdx.forEach((idx) => {
            this.dataBody[idx].value = "";
          });
        }
      } else if (key == "province") {
        this.fetchDataRegencies(val);
        this.dataBody[idxCity].value = "";
        this.dataBody[idxVillage].value = "";
      } else if (key == "city") {
        this.fetchDataDistrict(val);
        this.dataBody[idxVillage].value = "";
      }
    },
    addField(data) {
      let last = data.slice(-1)[0];
      data.push({ id: last.id + 1, val: "" });
    },
    removeField(i, data) {
      const index = data.findIndex((el) => {
        return el.id == i;
      });
      if (index > -1) {
        data.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    closeDateMenu(item, index) {
      this.showPicker = false;
      this.dataBody[index]["value"] == ""
        ? moment(this.date).format("dddd, MMMM Do YYYY")
        : "";
    },
    dataUniv() {
      let data = {
        path: `manage/univ/get`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optUniv = data.data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    async checkDataAddress() {
      if (this.person.province) {
        this.person.province = parseInt(this.person.province);
        this.fetchDataProvince();
        await this.fetchDataRegencies(this.person.province);
      }
      if (this.person.city) {
        this.person.city = parseInt(this.person.city);
        await this.fetchDataDistrict(this.person.city);
      }
      if (this.person.village) {
        this.person.village = parseInt(this.person.village);
      }
    },
    fetchCountry() {
      let data = {
        path: `region/country`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          let mutating = data.map((el) => {
            return { val: el.code, txt: el.name };
          });
          this.opt.country = mutating;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchDataProvince() {
      let data = {
        path: `region/province`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          let mutating = data.map((el) => {
            return { val: el.id, txt: el.name };
          });
          this.opt.province = mutating;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
     fetchDataRegencies(item) {
      let data = {
        path: `region/regency?province_id=${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then( (data) => {
          let mutating = data.map((el) => {
            return { val: el.id, txt: el.name };
          });
          this.opt.city = mutating;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
     fetchDataDistrict(item) {
      let data = {
        path: `region/district?regency_id=${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then( (data) => {
          let mutating = data.map((el) => {
            return { val: el.id, txt: el.name };
          });
          this.opt.village = mutating;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },

    deleteImage(index) {
      this.dataBody[index]["change"] = true;
      this.dataBody[index]["value"] = null;
    },
    // GET FORM ===================================================================================
    async getForm() {
      this.loading = true;
      this.dataBody = [];
      this.dataForm = null;
      let data = {
        path: `manage/scholar/form`,
        type: "form",
      };
      await this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataForm = data;
          for (let index = 0; index < this.dataForm.length; index++) {
            var tempName = this.dataForm[index].name.replace(/ /g, "");
            var tempLabel = this.dataForm[index].label;
            if (tempName == "acc_sosmed") {
              tempName = "acc_socmed";
            }
            this.dataBody.push({
              type: this.dataForm[index].type,
              name: tempName,
              risk:
                tempName == "nik" ||
                tempName == "bank_acc_number" ||
                tempName == "father_name" ||
                tempName == "mother_name"
                  ? true
                  : false,
              rules: tempName == "email" ? this.emailRules : [],
              need_country:
                tempName == "province" ||
                tempName == "city" ||
                tempName == "village"
                  ? true
                  : false,
              label: tempLabel,
              value:
                this.person[tempName] != null
                  ? this.person[tempName]
                  : this.dataForm[index].type == "text"
                  ? !this.person[tempName]
                    ? null
                    : this.person[tempName]
                  : "",
              required: this.dataForm[index].required,
              valueChange:
                this.dataForm[index].type == "text"
                  ? null
                  : this.person[tempName],
              change: false,
              category:
                tempName === "type" ||
                tempName === "nik" ||
                tempName === "name" ||
                tempName === "username" ||
                tempName === "email" ||
                tempName === "password" ||
                tempName === "gender" ||
                tempName === "phone_number" ||
                tempName === "wa_number" ||
                tempName === "dob" ||
                tempName === "birth_place" ||
                tempName === "religion" ||
                tempName === "etnic" ||
                tempName === "address" ||
                tempName === "province" ||
                tempName === "city" ||
                tempName === "village" ||
                tempName === "country" ||
                tempName === "post_code" ||
                tempName === "shirt_size" ||
                tempName === "tsg" ||
                tempName == "unique_code" ||
                tempName == "acc_socmed"
                  ? 0
                  : tempName === "year_ptn" ||
                    tempName === "year_tf" ||
                    tempName === "nim" ||
                    tempName === "no_tf" ||
                    tempName === "university_id" ||
                    tempName === "grouping_faculty" ||
                    tempName === "faculty" ||
                    tempName === "major" ||
                    tempName === "program" ||
                    tempName === "semester_sign" ||
                    tempName === "semester_now" ||
                    tempName === "assessment" ||
                    tempName === "grade" ||
                    tempName == "path_ptn"
                  ? 1
                  : tempName === "year_ptn" ||
                    tempName === "year_tf" ||
                    tempName === "historical_edu" ||
                    tempName === "achievement" ||
                    tempName === "orgs_activity" ||
                    tempName == "language_ability"
                  ? 2
                  : tempName === "father_name" ||
                    tempName === "father_birth_palce" ||
                    tempName === "father_email" ||
                    tempName === "father_phone_number" ||
                    tempName === "father_occupation" ||
                    tempName === "father_monthly_gross" ||
                    tempName === "father_latest_edu" ||
                    tempName === "mother_name" ||
                    tempName === "mother_birth_palce" ||
                    tempName === "mother_email" ||
                    tempName === "mother_phone_number" ||
                    tempName === "mother_occupation" ||
                    tempName === "mother_monthly_gross" ||
                    tempName === "mother_latest_edu" ||
                    tempName === "mother_dob" ||
                    tempName == "dependents"
                  ? 3
                  : tempName === "bank_acc_name" ||
                    tempName === "bank_acc" ||
                    tempName === "bank_acc_number" ||
                    tempName === "monthly_allowance" ||
                    tempName == "billed_ukt"
                  ? 4
                  : 5,
            });
            let keyObj = this.dataBody[index];
            if (tempName == "country" && keyObj.value == "ID") {
              this.fetchDataProvince();
            }

            if (this.dataBody[index]["name"] == "province") {
              if (this.dataBody[index]["value"]) {
                this.dataBody[index]["value"] = parseInt(
                  this.dataBody[index]["value"]
                );
                this.fetchDataRegencies(this.dataBody[index]["value"]);
              }
            }
            if (this.dataBody[index]["name"] == "city") {
              if (this.dataBody[index]["value"]) {
                this.dataBody[index]["value"] = parseInt(
                  this.dataBody[index]["value"]
                );
                this.fetchDataDistrict(this.dataBody[index]["value"]);
              }
            }
            if (this.dataBody[index]["name"] == "village") {
              if (this.dataBody[index]["value"]) {
                this.dataBody[index]["value"] = parseInt(
                  this.dataBody[index]["value"]
                );
              }
            }
            if (this.dataBody[index].type == "text") {
              if (
                this.dataBody[index]["name"] == "achievement" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.achievement[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["name"] == "historical_edu" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.historical_edu[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["name"] == "orgs_activity" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.orgs_activity[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["name"] == "acc_socmed" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el) => {
                  for (let j = 0; j < this.acc_socmed.length; j++) {
                    if (el.name == this.acc_socmed[j]["name"]) {
                      this.acc_socmed[j]["value"] = el.value;
                    }
                  }
                });
              }
              if (
                this.dataBody[index]["name"] == "mother_latest_edu" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.mother_latest_edu[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["name"] == "father_latest_edu" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.father_latest_edu[index]["val"] = el;
                });
              }
              if (
                this.dataBody[index]["name"] == "language_ability" &&
                this.dataBody[index]["value"] != null
              ) {
                let tempData = JSON.parse(this.dataBody[index]["value"]);
                tempData.forEach((el, index) => {
                  this.language_ability[index]["bahasa"] = el.bahasa;
                  this.language_ability[index]["Memiliki Sertifikasi"] =
                    el["Memiliki Sertifikasi"];
                  this.language_ability[index]["Jenis Tes"] = el["Jenis Tes"];
                  this.language_ability[index]["Skor"] = el["Skor"];
                  this.language_ability[index]["Tahun Sertifikat"] =
                    el["Tahun Srtifikat"];
                  this.language_ability[index]["No. Sertifikat"] =
                    el["No. Sertifikat"];
                  this.language_ability[index]["Nama Lembaga Bahasa"] =
                    el["Nama Lembaga Bahasa"];
                  this.language_ability[index]["Masa Berlaku"] =
                    el["Masa Berlaku"];
                });
              }
            }
          }
          this.loading = false;
          this.fetchCountry();
          this.opt.religion = this.optReligion;
        })
        .catch((e) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    updateData() {
      this.loading = true;
      let historical_edu = [];
      this.historical_edu.forEach((el) => {
        historical_edu.push(el.val);
      });
      let achievement = [];
      this.achievement.forEach((el) => {
        achievement.push(el.val);
      });
      let orgs_activity = [];
      this.orgs_activity.forEach((el) => {
        orgs_activity.push(el.val);
      });
      let father_latest_edu = [];
      this.father_latest_edu.forEach((el) => {
        father_latest_edu.push(el.val);
      });
      let mother_latest_edu = [];
      this.mother_latest_edu.forEach((el) => {
        mother_latest_edu.push(el.val);
      });
      let body = [];
      body.push(
        { id: this.person.user_id },
        {
          acc_socmed: JSON.stringify(this.acc_socmed),
        },
        {
          historical_edu: JSON.stringify(historical_edu),
        },
        {
          achievement: JSON.stringify(achievement),
        },
        {
          orgs_activity: JSON.stringify(orgs_activity),
        },
        {
          language_ability: JSON.stringify(this.language_ability),
        },
        {
          father_latest_edu: JSON.stringify(father_latest_edu),
        },
        {
          mother_latest_edu: JSON.stringify(mother_latest_edu),
        }
      );
      for (let index = 0; index < this.dataBody.length; index++) {
        if (
          this.dataBody[index].name != "acc_socmed" &&
          this.dataBody[index].name != "historical_edu" &&
          this.dataBody[index].name != "achievement" &&
          this.dataBody[index].name != "orgs_activity" &&
          this.dataBody[index].name != "language_ability" &&
          this.dataBody[index].name != "father_latest_edu" &&
          this.dataBody[index].name != "mother_latest_edu"
        ) {
          if (this.dataBody[index].type != "text") {
            if (this.dataBody[index].value) {
              if (
                this.dataBody[index].value != this.dataBody[index].valueChange
              )
                body.push({
                  [this.dataBody[index].name]: this.dataBody[index].value,
                });
            } else {
              if (this.dataBody[index].required) {
                this.error.push(this.dataBody[index].name);
              }
            }
          } else {
            if (this.dataBody[index].name == "address") {
              if (this.dataBody[index].value) {
                body.push({
                  [this.dataBody[index].name]: this.dataBody[index].value,
                });
              }
            }
            if (this.dataBody[index].valueChange) {
              body.push({
                [this.dataBody[index].name]: this.dataBody[index].valueChange,
              });
            } else {
              if (this.dataBody[index].required) {
                this.error.push(this.dataBody[index].name);
              }
            }
          }
        }
      }
      let data = {
        path: "manage/scholar/update",
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          console.log(data);
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.loading = false;
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
